import React from 'react';
import { Box } from "@mui/material";

import '../global.css'; // Adjust the path as necessary

const Spinner = () => (
  <Box className="spinner"></Box>
);

export default Spinner;